import { useEffect, useState } from 'react'
import { useAtomValue } from 'jotai'
import { CustomBreadCrumbConfig } from 'components/Breadcrumbs'
import { PathNames } from 'constants/General'
import { BusinessCustomerType, CustomerWallet, IndividualCustomerType } from 'types/customers'
import { currentCustomerAtom, currentCustomerWalletAtom } from '../atoms/customersAtoms'
import { isBusinessCustomer, isIndividualCustomer } from '../utils'

export const getCustomerBreadcrumbs = ({
  currentCustomer,
  currentCustomerWallet,
}: {
  currentCustomer: BusinessCustomerType | IndividualCustomerType
  currentCustomerWallet: CustomerWallet
}) => {
  const customerPageLink =
    currentCustomerWallet && `${PathNames.CUSTOMERS}/${currentCustomer?.reference}`

  const customerPageBreadcrumb = currentCustomer
    ? [
        ...(isBusinessCustomer(currentCustomer) && !!currentCustomer?.company?.name
          ? [
              {
                title: currentCustomer?.company?.name,
                link: customerPageLink,
              },
            ]
          : []),
        ...(isIndividualCustomer(currentCustomer) && !!currentCustomer?.person?.firstName
          ? [
              {
                title: `${currentCustomer?.person?.firstName} ${currentCustomer?.person?.lastName}`,
                link: customerPageLink,
              },
            ]
          : []),
      ]
    : []

  const customerWalletPageBreadcrumb = currentCustomerWallet
    ? [
        {
          title: currentCustomerWallet?.name,
        },
      ]
    : []
  return [...customerPageBreadcrumb, ...customerWalletPageBreadcrumb]
}

const useCustomerPageBreadcrumbs = () => {
  const [customerPageBreadcrumbs, setCustomerPageBreadcrumbs] = useState<CustomBreadCrumbConfig[]>(
    []
  )
  const currentCustomer = useAtomValue(currentCustomerAtom)
  const currentCustomerWallet = useAtomValue(currentCustomerWalletAtom)

  useEffect(() => {
    const breadcrumbs = getCustomerBreadcrumbs({ currentCustomer, currentCustomerWallet })
    setCustomerPageBreadcrumbs(breadcrumbs)
  }, [currentCustomer, currentCustomerWallet, location])

  return customerPageBreadcrumbs
}

export default useCustomerPageBreadcrumbs
